<template>
  <div class="info-box">
    <div class="info-box__content">
      <v-icon color="accent" size="17.5" class="mr-2">
        mdi-information
      </v-icon>
      <div>
        {{ text }}
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "TagsManagerDialogInfoBox",
  props: {
    text: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.info-box {
  display: flex;
  align-items: center;
  padding: $spacing * 1.1875 $spacing * 1.5;
  border-radius: 8px;
  background-color: $light-4;
  @include font-size(14px);
  line-height: 17px;
  gap: $spacing * 2;
  justify-content: space-between;
  width: 100%;
  color: $dark-blue-3;

  &__content {
    display: flex;
  }

  .v-icon {
    align-self: flex-start;
  }
}
</style>
